import { render, staticRenderFns } from "./BuildTwo.vue?vue&type=template&id=6be45a36&scoped=true"
import script from "./BuildTwo.vue?vue&type=script&lang=js"
export * from "./BuildTwo.vue?vue&type=script&lang=js"
import style0 from "./BuildTwo.vue?vue&type=style&index=0&id=6be45a36&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be45a36",
  null
  
)

export default component.exports